import React, { useState,useEffect } from "react";
import { HTTP } from "../../api/http-common";
import { useNavigate,Link } from "react-router-dom";
import { isValidEmail } from '../../component/common';
import { Eye, EyeOff } from "lucide-react";
import Swal from 'sweetalert2'
import { useGlobalContext } from "./../../component/GlobalContext";
import VendorAddressForm from "./VendorAddressForm";

function VendorAddress() {
    const navigate = useNavigate();
    // For Address
    const [addressError, setAddressError] = useState("");
    const [cityError, setCityError] = useState("");
    const [stateError, setStateError] = useState("");
    const [postalcodeError, setPostalcodeError] = useState("");
    const [longitudeError, setLongitudeError] = useState("");
    const [latitudeError, setLatitudeError] = useState("");
    
    const [total, setTotal] = useState(0);
    const [pagination, setPagination] = useState({ page: '1', limit: '10' });
    const [search, setSearch] = useState({ search_value: '' });

    const [addressesList, setAddressesList] = useState([]);

    const [formData, setFormData] = useState({
      id: 0,
      address: "",
      city_id: "",
      state: "",
      postal_code: "",
      longitude: "",
      latitude: "",
      is_mon_open: true,
      mon_open_time: "",
      mon_close_time: "",
      is_tue_open: true,
      tue_open_time: "",
      tue_close_time: "",
      is_wed_open: true,
      wed_open_time: "",
      wed_close_time: "",
      is_thu_open: true,
      thu_open_time: "",
      thu_close_time: "",
      is_fri_open: true,
      fri_open_time: "",
      fri_close_time: "",
      is_sat_open: true,
      sat_open_time: "",
      sat_close_time: "",
      is_sun_open: false,
      sun_open_time: "",
      sun_close_time: "",
    });

    useEffect(() => {
        loadVendorAddresses();
    }, []);
    
    const loadVendorAddresses = async () => {
        const access_token = localStorage.getItem('access_token');
        const config = {
            headers: { 'Content-Type': 'application/json', 'token': access_token },
        };
        let fields = {
            filters: {
              search_value: search.search_value,
            },
            pagination: pagination,
            sorting: { field: 'id', type: 'desc' },
        };
        HTTP.post("vendors_address/list", fields, config)
            .then((response) => {
                const data = response.data;
                if (response.status === 200) {
                  setAddressesList(data.contents);
                  
                }
            })
            .catch((error) => {
                console.log(error);
                if (error.response && error.response.status === 401) {
                  // Handle unauthorized error
                  localStorage.clear();
                  navigate('/'); // Redirect to login page
                }

            });
    }
    
      
  return (
    <>
    {Array.isArray(addressesList) && addressesList.length <= 10 ? (
      <VendorAddressForm key="0" addressesMain={formData} loadVendorAddresses={loadVendorAddresses} index="0"/>
      ) : (
        null
    )}
      {Array.isArray(addressesList) && addressesList.length > 0 ? (
          <>
              {addressesList.map((addressesMain, index) => (
                  <VendorAddressForm 
                  key={addressesMain.id}
                  addressesMain={addressesMain}
                  loadVendorAddresses={loadVendorAddresses}
                  index={index + 1}
                  
                  />
              ))}
          </>         
        ) : (
          null
      )}
    </>
  )
}

export default VendorAddress